import moment from 'moment';
import { CancelledPaymentsLogProps } from '../types';
import { isEmpty } from 'lodash';

export const transformCancelledPaymentsLogData = (
  cancelledPaymentsLogData: any
): CancelledPaymentsLogProps[] => {
  const DATE_FORMAT = 'DD-MMM-YYYY';
  const result: any = [];
  let srNo = 0;

  cancelledPaymentsLogData.map((record: any) => {
    let receivedOn: any, bouncedOn: any, cancelledOn: any;
    record.transactionStatusLogs.forEach((statusLog: any) => {
      if (statusLog.status === 'NOT DEPOSITED' && isEmpty(receivedOn)) {
        receivedOn = moment(statusLog.statusChangeDate).format(DATE_FORMAT);
      }
      if (statusLog.status === 'BOUNCED' && isEmpty(bouncedOn)) {
        bouncedOn = moment(statusLog.statusChangeDate).format(DATE_FORMAT);
      }
      if (statusLog.status === 'CANCELLED' && isEmpty(cancelledOn)) {
        cancelledOn = moment(statusLog.statusChangeDate).format(DATE_FORMAT);
      }
    });

    srNo++;
    return result.push({
      'Sr. No.': srNo,
      'Academic Year': record.academicYear,
      Class: record.grade,
      Section: record.section,
      'Receipt No': record.receiptNo,
      Student: record.studentName,
      'Receipt Amount': record.receiptAmount,
      'Deposit Date': receivedOn || '-',
      'Payment Mode': record.paymentMode,
      Reason: record.reason,
      'Component Type': record.componentType,
      'Cancelled By': record.cancelledBy,
      'Received By': record.receivedBy,
      'Cancelled On': cancelledOn || bouncedOn || '-',
      'Collection Type': record.collectionType
    });
  });

  return result;
};
